import * as dtc from '../services/dtc';

export default {
  namespace: 'dtc',
  state: {},
  effects: {
    //列表
    *queryEgcReportPage({ payload: { values }, callback }, { call, put }) {
      const response = yield call(dtc.queryEgcReportPage, values);
      yield put({
        type: 'save',
        payload: {
          dtcList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
